/* Sérénelle · page produit : carrousel, plein écran, prix du coffret choisi */
(() => {
  'use strict';
  const reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ——— Carrousel : défilement natif (scroll-snap), synchronisé avec vignettes, compteur et barre ——— */
  const brancher = (racine, { surChange } = {}) => {
    const piste = racine.querySelector('.fi-piste');
    if (!piste) return null;
    const slides = Array.from(piste.children);
    const vigs = Array.from(racine.querySelectorAll('.fi-rail button'));
    const rail = racine.querySelector('.fi-rail');
    const compte = racine.querySelector('.fi-compteur b');
    let actif = 0;

    const precharger = (i) => {
      [i, i + 1, i + 2, i - 1].forEach((k) => {
        const s = slides[(k + slides.length) % slides.length];
        const img = s && s.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      });
    };
    const marquer = (i) => {
      if (i === actif && racine.dataset.pret) return;
      actif = i;
      racine.dataset.pret = '1';
      racine.style.setProperty('--i', i);
      slides.forEach((s, k) => {
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        const v = s.querySelector('video');
        if (v) { if (k === i) v.play().catch(() => {}); else v.pause(); }
      });
      vigs.forEach((b, k) => b.setAttribute('aria-current', k === i ? 'true' : 'false'));
      if (compte) compte.textContent = String(i + 1);
      const v = vigs[i];
      if (v && rail) {
        const vertical = rail.scrollHeight > rail.clientHeight + 2;
        if (vertical) rail.scrollTo({ top: v.offsetTop - rail.clientHeight / 2 + v.clientHeight / 2, behavior: reduit ? 'auto' : 'smooth' });
        else rail.scrollTo({ left: v.offsetLeft - rail.clientWidth / 2 + v.clientWidth / 2, behavior: reduit ? 'auto' : 'smooth' });
      }
      precharger(i);
      if (surChange) surChange(i);
    };
    const aller = (i, doux = true) => {
      i = (i + slides.length) % slides.length;
      piste.scrollTo({ left: i * piste.clientWidth, behavior: doux && !reduit ? 'smooth' : 'auto' });
      marquer(i);
    };

    let att = 0;
    piste.addEventListener('scroll', () => {
      if (att) return;
      att = requestAnimationFrame(() => {
        att = 0;
        const i = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
        marquer(Math.max(0, Math.min(slides.length - 1, i)));
      });
    }, { passive: true });

    vigs.forEach((b, k) => b.addEventListener('click', () => aller(k)));
    const prec = racine.querySelector('.fi-prec'), suiv = racine.querySelector('.fi-suiv');
    if (prec) prec.addEventListener('click', () => aller(actif - 1));
    if (suiv) suiv.addEventListener('click', () => aller(actif + 1));
    piste.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); aller(actif + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); aller(actif - 1); }
    });

    /* Souris : glisser pour faire défiler (le tactile utilise le défilement natif) */
    let x0 = null, s0 = 0, bouge = false;
    piste.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      x0 = e.clientX; s0 = piste.scrollLeft; bouge = false;
      piste.style.scrollSnapType = 'none'; piste.style.scrollBehavior = 'auto';
    });
    addEventListener('pointermove', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      if (Math.abs(dx) > 4) bouge = true;
      piste.scrollLeft = s0 - dx;
    });
    addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0; x0 = null;
      piste.style.scrollSnapType = ''; piste.style.scrollBehavior = '';
      if (bouge) aller(actif + (dx < -40 ? 1 : dx > 40 ? -1 : 0));
    });
    piste.addEventListener('click', (e) => { if (bouge) { e.preventDefault(); e.stopPropagation(); bouge = false; } }, true);

    addEventListener('resize', () => piste.scrollTo({ left: actif * piste.clientWidth, behavior: 'auto' }));
    marquer(0);
    return { aller, get actif() { return actif; }, piste, slides };
  };

  const galerie = document.querySelector('[data-carrousel]');
  const vue = document.getElementById('fiVue');
  if (galerie) {
    const principal = brancher(galerie);
    /* ——— Plein écran ——— */
    if (principal && vue && typeof vue.showModal === 'function') {
      const grand = brancher(vue);
      const ouvrir = (i) => {
        vue.showModal();
        document.documentElement.classList.add('fi-vue-ouverte');
        requestAnimationFrame(() => grand.aller(i, false));
      };
      const fermer = () => {
        vue.querySelectorAll('.fi-slide.zoom').forEach((s) => s.classList.remove('zoom'));
        vue.close();
      };
      vue.addEventListener('close', () => {
        document.documentElement.classList.remove('fi-vue-ouverte');
        principal.aller(grand.actif, false);
      });
      principal.slides.forEach((s, k) => s.addEventListener('click', () => ouvrir(k)));
      const loupe = galerie.querySelector('.fi-zoom');
      if (loupe) loupe.addEventListener('click', () => ouvrir(principal.actif));
      vue.querySelector('.fi-fermer').addEventListener('click', fermer);
      /* Zoom : un clic (ou double appui) agrandit à l'endroit touché */
      grand.slides.forEach((s) => {
        const img = s.querySelector('img');
        if (!img) return;
        s.addEventListener('click', (e) => {
          if (s.classList.contains('zoom')) { s.classList.remove('zoom'); return; }
          const r = img.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          s.classList.add('zoom');
        });
      });
      grand.piste.addEventListener('scroll', () => {
        vue.querySelectorAll('.fi-slide.zoom').forEach((s) => s.classList.remove('zoom'));
      }, { passive: true });
    } else if (principal) {
      galerie.classList.add('fi-sans-vue');
    }
  }

  /* ——— Prix affiché selon le coffret choisi ——— */
  const prix = document.getElementById('fiPrix'), plein = document.getElementById('fiPlein'), eco = document.getElementById('fiEco');
  const offres = Array.from(document.querySelectorAll('.lis-offre'));
  const majPrix = () => {
    const o = offres.find((x) => x.querySelector('input').checked);
    if (!o) return;
    if (prix) prix.textContent = o.dataset.prix;
    if (plein) { plein.textContent = o.dataset.plein || ''; plein.hidden = !o.dataset.plein; }
    if (eco) { eco.textContent = o.dataset.eco || ''; eco.hidden = !o.dataset.eco; }
  };
  offres.forEach((o) => o.querySelector('input').addEventListener('change', majPrix));
  majPrix();
})();
